import React, { PureComponent } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';

import Box from 'components/Box';

import cxHelpers from 'util/className';

import { THEMES } from './constants';
import Tab from './Tab';

/*
Individual tabs can be created two ways:
1. Via the `tabs` prop, as a List of tab configs (see propTypes for details).
2. Directly via `children`. The `Tab` component is exported for this purpose.
*/
@cxHelpers('Tabs')
export default class Tabs extends PureComponent {
  static propTypes = {
    tabs: ImmutablePropTypes.listOf(
      PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        className: PropTypes.string,
        indicator: PropTypes.bool,
      })
    ),
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    theme: PropTypes.oneOf(THEMES),
  };

  static defaultProps = {
    theme: THEMES[0],
  };

  render() {
    const { tabs, value, onChange, theme } = this.props;

    return (
      <Box className={this.cx({ theme })} vbottom>
        {tabs.map(tabProps => (
          <Tab
            key={tabProps.value}
            {...tabProps}
            onChange={onChange}
            active={tabProps.value === value}
            theme={theme}
          />
        ))}
      </Box>
    );
  }
}
